import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { DefaultButton, Stack } from 'office-ui-fabric-react';
import { toggleServerEnabled } from '../../components/Requests/Requests';


export class StatsCard extends Component {
  toggleServer = (enabled, regionName, server, index) => {
    this.setState({serverToggleLoading: true});
    if(enabled){
        this.props.updateServerToggle(false, regionName, server, index)
        this.toggleServerAction(0, server.serverName, index);//debounce this
    }else{
        this.props.updateServerToggle(true, regionName, server, index)
        this.toggleServerAction(1, server.serverName, index);
    }
  }

  toggleServerAction = (enabled, serverName, index) =>{ 
    return toggleServerEnabled(this.props.accessToken, enabled, serverName, index).then((response) => {
      response.json().then(() => {
        if(response.status === 200){
          this.props.updateServerToggle(enabled === 1 ? true : false, index)//update the props for the render
          this.setState({serverToggleLoading: false})
        }else{
          console.log(response);
        }
      });
    })
  }

  getIcon = (enabled, serverName) =>{

    if (serverName) {
    return enabled ? (<div className="text-center icon-med"> {this.props.bigIcon}</div>) :
                (<div className="text-center icon-med"><i className="fa fa-stop-circle-o text-danger"></i></div>);
    }
    else {
      return '';
    }
  }

  render() {
    return (
      <div className="card card-stats">
        <div className="content">
          <Row>
            <Col xs={10}>
              <div className="numbers">
                <p>{this.props.statsText}</p>
                {this.props.statsValue}<br/>
                {this.props.statsNote}
              </div>
            </Col>
            <Col xs={2}>
              {
                this.getIcon(this.props.enabled, this.props.serverName)
              }
            </Col>
          </Row>
          <div className="footer">
            {this.props.serverActions !==null && 
              <Stack horizontal tokens={{ childrenGap: 40 }}>
                <DefaultButton text={this.props.enabled ? "Pause server" : "Start Server"} onClick={() =>this.toggleServer(this.props.enabled,this.props.regionName,this.props.server, this.props.index)}><i className={this.props.enabled ? "fa fa-pause-circle-o" : "fa fa-play-circle-o"} /></DefaultButton>
              </Stack> 
            }        
            <hr />
            <div className="stats">
              {this.props.statsIconText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StatsCard;
